export const CUSTOM_USER_INFO = {
  tsmbu: {
    authorizeInfo: {
      mobile: '15524147728',
      status: 'OK',
      token: '6c803f53-9580-4e64-b6d4-0be85e3a3d9f',
      userId: null,
      qwUserId: 'LiuYue',
      appId: '1000060'
    },
    usersCurrentInfo: {
      id: '144115205303168663',
      gender: 'U',
      name: '1473535434722418688',
      isInitial: 'N',
      mobile: '15524147728',
      avatar: 'http://wework.qpic.cn/wwhead/duc2TvpEgSQl4wxMPWAVtyV2YYZ9SKaZpJBZhvlFsKfUb4S87uicFgNgk6bmD8nO3zw6Ea4WxsdM/0',
      userName: '刘越',
      roles: [
        '6170179c9f1283001a0db158'
      ],
      status: 'ENABLE',
      mainTenant: '6170179c9f1283001a0db141',
      tenant: '6170179c9f1283001a0db141',
      org: ['619cf754dd821e002be2c293'],
      extra: '{"ToUserName":"ww754a162f2fe3481f","FromUserName":"sys","CreateTime":1640153199319,"MsgType":"event","Event":"change_contact","ChangeType":"create_user","UserID":"1473535434722418688","Name":"刘越","Mobile":15524147728,"Gender":"null","Email":"","Avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSQl4wxMPWAVtyV2YYZ9SKaZpJBZhvlFsKfUb4S87uicFgNgk6bmD8nO3zw6Ea4WxsdM/0","Department":"1023","IsLeaderInDept":"0","MainDepartment":"1023","Status":"1","Alias":"","Telephone":"","Address":""}',
      birthday: null,
      tenantList: [],
      permApiList: [],
      permIdList: [],
      permList: []
    }
  },
  gm: {
    authorizeInfo: {
      mobile: '15524147728',
      status: 'OK',
      token: 'ee6c4e33-da0d-45f1-9279-bf0bf6d18196',
      userId: null,
      qwUserId: 'liuyue',
      appId: '1000003'
    },
    usersCurrentInfo: {
      id: '144115205301725086',
      gender: 'U',
      name: '1561601281499635712',
      isInitial: 'N',
      mobile: '15524147728',
      avatar: 'http://wework.qpic.cn/wwhead/duc2TvpEgSQl4wxMPWAVtyV2YYZ9SKaZpJBZhvlFsKfUb4S87uicFgNgk6bmD8nO3zw6Ea4WxsdM/0',
      userName: '刘越',
      roles: [
        '62ff4ad399436b02aead081f'
      ],
      status: 'ENABLE',
      mainTenant: '62f5da1950931500412a9d69',
      tenant: '62f5da1950931500412a9d69',
      org: ['62ff48a899436b02aead0812'],
      extra: '{"ToUserName":"ww754a162f2fe3481f","FromUserName":"sys","CreateTime":1640153199319,"MsgType":"event","Event":"change_contact","ChangeType":"create_user","UserID":"1561601281499635712","Name":"刘越","Mobile":15524147728,"Gender":"null","Email":"","Avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSQl4wxMPWAVtyV2YYZ9SKaZpJBZhvlFsKfUb4S87uicFgNgk6bmD8nO3zw6Ea4WxsdM/0","Department":"1023","IsLeaderInDept":"0","MainDepartment":"1023","Status":"1","Alias":"","Telephone":"","Address":""}',
      birthday: null,
      tenantList: [],
      permApiList: [],
      permIdList: [],
      permList: []
    }
  },
  audi: {
    authorizeInfo: {
      mobile: '15524147728',
      status: 'OK',
      token: '2610e3f1-1bcb-40f0-857c-d860cf7b18fc',
      userId: null,
      qwUserId: 'astarliu',
      appId: '1000061'
    },
    usersCurrentInfo: {
      id: '144115205301725656',
      gender: 'F',
      name: '15524147728',
      isInitial: 'N',
      mobile: '15524147728',
      avatar: 'http://wework.qpic.cn/bizmail/FEetQyxpta5z6jspXtQbk61BXCTsC66QEskeic8UaYSpN9oXIKp7VfQ/0',
      userName: '刘越',
      roles: [
        '60b7755e67255e001a595648',
        '60bf018712549f001a1d0a4f',
        '60bdddbf35494e001a718038',
        '60b9ebcb35494e001a71802a',
        '6113684c773d1b001a1c9db2',
        '6189d511f74398001affd980',
        '620b8d8e0c7531002011974c',
        '611b3155b3a0b401414f7855',
        '6115f713f2c2f3001ad10075',
        '6115f2a0f2c2f3001ad1006e',
        '6115f27bf2c2f3001ad1006c',
        '61136883773d1b001a1c9db4',
        '611673e9f2c2f3001ad100f7',
        '6115f2fdf2c2f3001ad10072',
        '6115f2d6f2c2f3001ad10070',
        '613d8105b2f822001adb852a',
        '616f86c224cafa001a5fc83c'
      ],
      status: 'ENABLE',
      mainTenant: '60b7755d67255e001a595646',
      tenant: '60b7755d67255e001a595646',
      org: ['6114cc5757dc7c001ae3e1ef'],
      extra: '{"userid":"15524147728","name":"刘越","mobile":"15524147728","order":null,"position":"","gender":2,"email":"","avatar":"http://wework.qpic.cn/bizmail/FEetQyxpta5z6jspXtQbk61BXCTsC66QEskeic8UaYSpN9oXIKp7VfQ/0","telephone":"","alias":"","address":"","status":1,"extattr":null,"department":[1],"is_leader_in_dept":null,"thumb_avatar":"http://wework.qpic.cn/bizmail/CWicdedfdKfes0Geb5pH4nmCou99VA5jc72kS0Cl1U6dbXkvViass3EQ/100","qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc234264760ed260c0","external_profile":null,"external_position":null,"open_userid":null,"main_department":null}',
      birthday: null,
      tenantList: [],
      permApiList: [],
      permIdList: [],
      permList: []
    }
  }
}
